import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-efbb4b5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "info-wrap" }
const _hoisted_3 = { class: "title-item" }
const _hoisted_4 = { class: "create-time" }
const _hoisted_5 = { class: "status-wrap" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-right" }, null, -1))
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "empty-text xag-flex-center"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", null, "暂无贷款信息")
], -1))
const _hoisted_10 = [
  _hoisted_9
]

import { useRouter } from 'vue-router'
import { PullRefresh, List } from 'vant'
import { computed } from 'vue'
import { XssCommonPageListQuery } from '@/types/public'
import { commonErrorHandle } from '@/utils/error-handle'
import { requestAgriculturaLoanApplyList } from '@/apis/agricultura-loan'
import { AgriculturalLoanContractDetailRouteName } from '@/defination/constant'
import { AgriculturaLoanOrderStatusColorMap } from '@/defination/agricultura-loan'
import { useArgiculturaLoanKeepAliveControll } from '@/compositions/agricultura-loan/index'
import type {
  AgriculturalLoanOrderListResponse,
  AgriculturalLoanOrderItem,
} from '@/types/agricultura-loan'
import useCommonList from '@/compositions/useCommonList'


export default /*#__PURE__*/_defineComponent({
  __name: 'loan-contract-list',
  emits: ['change', 'deviceSnMapChange'],
  setup(__props, { emit: emits }) {


const $router = useRouter()

const { addContractListKeepAlive, removeContractListKeepAlive } =
  useArgiculturaLoanKeepAliveControll()

function getStatusTextColor(itme: AgriculturalLoanOrderItem) {
  return {
    // 默认使用灰色
    color: AgriculturaLoanOrderStatusColorMap.get(itme.status || 6),
  }
}

async function queryList(
  params: XssCommonPageListQuery
): Promise<AgriculturalLoanOrderListResponse> {
  console.log('params', params)
  try {
    const data = await requestAgriculturaLoanApplyList(params)
    return data
  } catch (error) {
    commonErrorHandle(error)
    return Promise.reject(error)
  }
}
const {
  refreshing,
  loading,
  requestError,
  finished,
  onRefresh,
  dataList,
  queryHandle,
  finishedText,
  unshiftDataList,
} = useCommonList<AgriculturalLoanOrderItem, XssCommonPageListQuery>(queryList, {
  emptyText: '暂无设备',
})

const renderList = computed(() => {
  return dataList.value
})

function clickHandle(item: AgriculturalLoanOrderItem) {
  addContractListKeepAlive()
  $router.push({
    name: AgriculturalLoanContractDetailRouteName,
    query: {
      number: item.number,
    },
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PullRefresh), {
    modelValue: _unref(refreshing),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(refreshing) ? (refreshing).value = $event : null)),
    onRefresh: _unref(onRefresh),
    disabled: "",
    class: "list-wrap"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(List), {
        loading: _unref(loading),
        "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => (_isRef(loading) ? (loading).value = $event : null)),
        error: _unref(requestError),
        "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => (_isRef(requestError) ? (requestError).value = $event : null)),
        finished: _unref(finished),
        offset: 200,
        "finished-text": _unref(finishedText),
        "error-text": "加载失败",
        onLoad: _unref(queryHandle),
        class: _normalizeClass(["list-container", _unref(renderList).length === 0 ? 'empty-wrap' : ''])
      }, {
        finished: _withCtx(() => [
          (_unref(renderList).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(finishedText)), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(renderList), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "order-item",
              key: item.contract_number,
              onClick: _withModifiers(($event: any) => (clickHandle(item)), ["stop"])
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, "货款合同号: " + _toDisplayString(item.number), 1),
                _createElementVNode("div", _hoisted_4, "申请时间: " + _toDisplayString(item.create_at), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: "status-text",
                  style: _normalizeStyle(getStatusTextColor(item))
                }, _toDisplayString(item.status_text), 5),
                _hoisted_6
              ])
            ], 8, _hoisted_1))
          }), 128))
        ]),
        _: 1
      }, 8, ["loading", "error", "finished", "finished-text", "onLoad", "class"])
    ]),
    _: 1
  }, 8, ["modelValue", "onRefresh"]))
}
}

})